import { useEffect } from "react";
import { useSelector } from "react-redux";

export const useFilterSidebar = (props = {}) => {
  const { ConfigData } = useSelector((state) => state.homePageSlice);
  const newFilterCategoryIds =
    ConfigData?.new_filter_catogory?.split(",").map((id) => Number(id)) || [];
  const {
    setFilters,
    filtersListing,
    selectedFilters,
    setSelectedFilters,
    initialFilter,
    searchInput,
    categoryId,
  } = props;

  const handleCheckboxChange = (filter, option) => {
    if (filter.attribute_code === "price") {
      const isAnyOptionSelected = selectedFilters.some((selected) =>
        filter.options.some(
          (option) =>
            option.label === selected.label && option.value === selected.value
        )
      );

      if (isAnyOptionSelected) {
        if (
          selectedFilters.some(
            (filter) =>
              filter.label === option.label && filter.value === option.value
          )
        ) {
          return;
        } else {
          const updatedFilters = selectedFilters.filter(
            (selected) => !filter.options.includes(selected)
          );
          setSelectedFilters([...updatedFilters, option]);
        }
      } else {
        setSelectedFilters([...selectedFilters, option]);
      }
    } else {
      const categoryIncludes = newFilterCategoryIds?.includes(categoryId);

      if (categoryIncludes) {
        const updatedFilters = selectedFilters.filter(
          (selected) =>
            !filter.options.some(
              (opt) =>
                opt.label === selected.label && opt.value === selected.value
            )
        );

        setSelectedFilters([...updatedFilters, option]);
      } else {
        const isOptionSelected = selectedFilters.some(
          (filter) =>
            filter.label === option.label && filter.value === option.value
        );

        const updatedFilters = isOptionSelected
          ? selectedFilters.filter(
              (selected) =>
                selected.label !== option.label ||
                selected.value !== option.value
            )
          : [...selectedFilters, option];

        setSelectedFilters(updatedFilters);
      }
    }
  };

  const generateFilterObject = () => {
    const filterObject = {};

    selectedFilters.forEach((value) => {
      let selectedOption = filtersListing
        .flatMap((filter) =>
          filter.options.map((option) => ({
            ...option,
            attribute_code: filter.attribute_code,
          }))
        )
        .find(
          (option) =>
            option.label === value.label || option.value === value.value
        );

      if (!selectedOption) {
        selectedOption = {
          attribute_code: "price",
          value: value.value,
        };
      }

      if (selectedOption) {
        const { attribute_code, value } = selectedOption;
        const updatedAttributeCode =
          attribute_code === "category_uid" ? "category_id" : attribute_code;

        if (updatedAttributeCode === "price") {
          const [from, to] = value.split("_");
          filterObject[updatedAttributeCode] = { from, to };
        } else {
          if (!filterObject[updatedAttributeCode]) {
            filterObject[updatedAttributeCode] = { eq: value };
          } else {
            if (!Array.isArray(filterObject[updatedAttributeCode].in)) {
              filterObject[updatedAttributeCode].in = [
                filterObject[updatedAttributeCode].eq,
              ];
              delete filterObject[updatedAttributeCode].eq;
            }
            filterObject[updatedAttributeCode].in.push(value);
          }
        }
      }
    });

    return filterObject;
  };

  useEffect(() => {
    const filterObject = generateFilterObject();

    const updatedFilters =
      Object.keys(filterObject).length > 0
        ? { ...initialFilter, ...filterObject }
        : searchInput
        ? { ...initialFilter, name: { match: searchInput } }
        : { ...initialFilter };

    setFilters(updatedFilters);
  }, [selectedFilters, filtersListing]);

  return {
    handleCheckboxChange,
    ConfigData,
  };
};
